import { t } from "i18next";
import ReactSelect from "react-select";
import cn from 'classnames';
import { getInstitutionCodes } from "@services/institutions";
import { useEffect, useState } from "react";
import { getStoredFilters } from "@utils/filters";
import { PATIENT_KEY } from "@utils/constants";


const InstitutionCodeSelector = ({ onChange, className ,customStyles }: { onChange: Function, className: any ,customStyles: any; }) => {
    const [codeOptions, setCodeOptions] = useState<any>([]);
    const storedValue = getStoredFilters(PATIENT_KEY);
    const defaultValue = storedValue.institutionCode ? { value: storedValue.institutionCode, label: storedValue.institutionCode } : null;

    const getCodes = async () => {
        try {
            const data = await getInstitutionCodes();
            if (data.length) {
                const options = data.map((item: any) => {
                    return { value: item, label: item };
                });
                options.splice(0, 0, { value: 'all', label: t('all') });
                setCodeOptions([...options]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getCodes();
    }, []);

    return (
        <div className={cn(className)}>
            <ReactSelect
                className={cn("select", " h-[36px] w-[170px] 2xl:w-[200px] py-0")}
                defaultValue={defaultValue}
                options={codeOptions}
                styles={customStyles}
                placeholder={t('institutionCode')}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: '#ED5939',
                        primary25: '#F4F4F4',
                    },
                })}
                onChange={({ value }: any) => onChange(value)}
            />
        </div>);
};

export default InstitutionCodeSelector;